
import { Badge } from "@/components/ui/badge";
import { Loader2 } from "lucide-react";

interface StatusBadgeProps {
  status: string;
  isUpdating: boolean;
}

const StatusBadge = ({ status, isUpdating }: StatusBadgeProps) => {
  // Determine the badge color based on status
  const getBadgeClasses = (currentStatus: string) => {
    switch (currentStatus.toLowerCase()) {
      case 'pending':
        return "bg-yellow-100 text-yellow-800";
      case 'approved':
      case 'completed':
      case 'resolved':
        return "bg-green-100 text-green-800";
      case 'denied':
      case 'rejected':
        return "bg-red-100 text-red-800";
      default:
        return "bg-blue-100 text-blue-800";
    }
  };

  return (
    <Badge className={getBadgeClasses(status)}>
      {status}
      {isUpdating && (
        <Loader2 className="h-3 w-3 ml-1 animate-spin" />
      )}
    </Badge>
  );
};

export default StatusBadge;
